import _ from 'lodash';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Swipeable from 'react-swipeable';
import { bylineToString, getLocalLink } from 'utils/NewsUtils';
import * as AnalyticsUtils from 'utils/AnalyticsUtils';
import ComponentTitle from '../shared/ComponentTitle';
import Timestamp from 'components/Timestamp';
import SlideshowIcon from 'components/icons/Slideshow';
import Pagination from 'components/icons/Pagination';
import AdvertisementUnit from 'components/AdvertisementUnit';
import Image from 'components/Image';
import Pause from 'components/icons/Pause';
import injectTapEventPlugin from 'react-tap-event-plugin';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';
import { setMetaTags } from 'lib/frankly';
import { getSessionStorage, setSessionStorage, removeSessionStorage } from '../../utils/SessionStorageUtil';
import { TAB_EVENT_INJECTED } from '../../constants/SessionStorageKey';

const CLIP = 'clip';
const WIDGETS = 'widgets';
const IMAGE_GALLERY = 'ImageGallery';

const TRANSITION_NEXT_CLASSNAME = 'transitionNext';
const TRANSITION_BACK_CLASSNAME = 'transitionBack';

const BREAKPOINTS = [
  { numberOfGridColumn: 2, numberOfGridItems: 8, minWidth: 0 },
  { numberOfGridColumn: 3, numberOfGridItems: 12, minWidth: 768 },
  { numberOfGridColumn: 4, numberOfGridItems: 16, minWidth: 992 }
];

// 5 minutes for each enject
const INJECT_TAP_EVENT_PLUGIN_TIME = 5 * 60 * 1000;

const SlideshowPropTypes = {
  backgroundColor: PropTypes.string,
  showCaption: PropTypes.bool,
  captionBackgroundColor: PropTypes.string,
  captionTextColor: PropTypes.string,
  showPagination: PropTypes.bool,
  maintainImageAspectRatio: PropTypes.bool,
  imageAspectRatioBackgroundColor: PropTypes.string,
  videoIconPlacement: PropTypes.oneOf(['center', 'bottom-left', 'bottom-right', 'top-left', 'top-right']),
  ads: PropTypes.array,
  showAds: PropTypes.bool,
  adPlacementPattern: PropTypes.number,
  showScrollBarOnGridview: PropTypes.bool,
  showDrawer: PropTypes.bool,
  showSettingsPill: PropTypes.bool,
  settingsPillProperties: PropTypes.shape({
    share: PropTypes.bool,
    fullScreen: PropTypes.bool,
    gridView: PropTypes.bool,
    imageCounter: PropTypes.bool
  }),
  selectedHighlightColor: PropTypes.string,
  autoChangeInterval: PropTypes.number,
  autoPause: PropTypes.bool,
  showBylines: PropTypes.bool,
  showTimestamp: PropTypes.bool, 
  showUpdatedDate: PropTypes.bool, 
  timestampOptions: PropTypes.shape({
    showElapsedTime: PropTypes.bool, 
    displayShortDateTime: PropTypes.bool
  }), 
  showDescription: PropTypes.bool,
  showTitle: PropTypes.bool, 
  enableImageAnalytics: PropTypes.bool, 
  addMetaTags: PropTypes.bool, 
  mode: PropTypes.oneOf(['feed', 'manual']),
  enableAdRefresh: PropTypes.bool
};

class SlideshowWrapper extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    title: PropTypes.string,
    titleColor: PropTypes.string,
    startArticleIndex: PropTypes.number,
    numberOfItems: PropTypes.number,
    titleType: PropTypes.string,
    hasStoryImages: PropTypes.bool,
    ...SlideshowPropTypes
  }

  static defaultProps = {
    startArticleIndex: 0,
    numberOfItems: 100,
    showPagination: true,
    showDrawer: true,
    showSettingsPill: true,
    settingsPillProperties: {
      share: true,
      fullScreen: true,
      gridView: true,
      imageCounter: true
    },
    videoIconPlacement: 'center',
    showScrollBarOnGridview: true,
    showCaption: true,
    maintainImageAspectRatio: false,
    autoPause: false,
    ads: [],
    showAds: false,
    adPlacementPattern: 3,
    autoChangeInterval: 0,
    showTimestamp: true,
    showUpdatedDate: false,
    showBylines: true,
    timestampOptions: {
      showElapsedTime: true,
      displayShortDateTime: true
    },
    showDescription: true,
    showTitle: true,
    titleType: TITLE_TYPE.MODULE_TITLE,
    addMetaTags: false,
    hasStoryImages: false
  }

  constructor(props) {
    super(props);
    if (typeof window !== 'undefined') {
      const tabEventInjected = getSessionStorage(TAB_EVENT_INJECTED);
      //we inject tab event plugin only one time
      if (tabEventInjected && new Date().getTime() - tabEventInjected < INJECT_TAP_EVENT_PLUGIN_TIME) return;

      injectTapEventPlugin({
        shouldRejectClick: () => {
          return true;
        }
      });

      setSessionStorage(TAB_EVENT_INJECTED, new Date().getTime());
    }
  }

  componentWillMount() {   
    let items = [];
    if (this.props.hasStoryImages) {
      items = this._getStoryImages();
    } else {
      items = this._getVideoItems() || this._getImagesGallery();
    }
    this.setState({ items });
  }

  componentWillUnmount() {
    removeSessionStorage(TAB_EVENT_INJECTED);
  }
  componentWillMount() {   
    let items = [];
    if (this.props.hasStoryImages) {
      items = this._getStoryImages();
    } else {
      items = this._getVideoItems() || this._getImagesGallery();
    }

    this.setState({ items });
  }
  _getVideoItems() {
    const {
      FRN_rawResponses: [{
        data: {
          id: widgetId,
          headline: widgetHeadline,
          contentClassification: adTag,
          features = []
        } = {}
      } = {}] = [],
      enableImageAnalytics
    } = this.props;

    const items = features.filter(item => item.type === CLIP);

    if (!items.length) {
      return null;
    }

    return [
      {
        headline: widgetHeadline,
        data:
          this._sliceItems(items).map(item => {
            const {
              id = '',
              headline: smallHeadline = '',
              bylines = [],
              link = '',
              abstractimage: {
                filename: url = '',
                lastEditedDate = ''
              } = {},
              publishedDate: publishingDate = '',
              updatedDate = '',
              abstract: description = '',
              type = '',
              seo: { pageurl: slug = '' } = {}
            } = item;

            let metaData;

            if (enableImageAnalytics) {
              metaData = {
                widgetId,
                widgetHeadline,
                adTag
              };
            }

            return {
              headline: smallHeadline,
              url,
              lastEditedDate,
              description,
              publishingDate,
              updatedDate,
              bylines,
              id,
              link,
              type,
              slug,
              ...metaData
            };
          })
      }
    ];
  }

  _getImagesGallery() {
    const {
      FRN_rawResponses: [{
        data: {
          headline = '',
          link = '',
          features = [],
          bylines = [],
          // Get from widget API
          widgets = [],
          seo: {
            description = '',
            keywords = '',
            robot = '',
            canonicallink,
          } = {},
        } = {},
      } = {}] = [],
      enableImageAnalytics,
      addMetaTags = false
    } = this.props;

    let finalHeadline = widgets.length > 0 ? widgets[0].headline : headline;

    if (addMetaTags) {
      setMetaTags(this, [{
        name: 'description',
        content: description
      }, {
        name: 'keywords',
        content: keywords
      }, {
        name: 'robots',
        content: robot
      }, {
        rel: 'canonical',
        href: canonicallink || link,
        isLink: true
      }, {
        property: 'og:title',
        content: finalHeadline
      }, {
        property: 'og:type',
        content: 'article'
      }, {
        property: 'og:url',
        content: link
      },
      // TO DO
      //  {
      //   property: 'og:image',
      //   content: heroImageFilename
      // }, 
      {
        property: 'og:description',
        content: description
      }, {
        name: 'twitter:card',
        content: 'summary_large_image'
      }, {
        name: 'twitter:description',
        content: description
      }, {
        name: 'twitter:title',
        content: finalHeadline
      },
        // TO DO
        // {
        //   name: 'twitter:image',
        //   content: heroImageFilename
        // }
      ]);
    }

    let multiItems;
    const widgetsData = widgets.length > 0 ? [widgets[0]] : features.filter(item => item.type === WIDGETS);
    if (widgetsData.length) {
        multiItems = widgetsData.map(widget => {
        let metaData;
        let items = {
          headline: widget.headline || '',
          data: []
        };

        const imagesGallery = widget.json.find(item => item.Type === IMAGE_GALLERY);

        if (imagesGallery) {
          items.data = imagesGallery.images || [];

          if (enableImageAnalytics) {
            const {
              id: widgetId
            } = widget;

            const {
              slideshowHeadline: widgetHeadline,
              adTag
            } = imagesGallery;

            metaData = {
              widgetId,
              widgetHeadline,
              adTag
            };
          }
        }

        if (items.data.length) {
          items.data = this._sliceItems(items.data).map(item => {
            _.assign(item, {
              bylines,
              ...metaData
            });

            return {
              bylines,
              ...item,
              ...metaData
            };
          });
        }
        return items.data.length ? items : null;
      });    
    }
    
    return multiItems;
  }

  _getStoryImages() {
    const {
      FRN_rawResponses: [{
        data: {
          id: widgetId,
          headline: widgetHeadline,
          contentClassification: adTag,
          storyimages: storyImages = [],
          bylines = []
        } = {}
      } = {}] = [],
      enableImageAnalytics
    } = this.props;

    if (!storyImages.length) {
      return null;
    }

    const items = storyImages.map(item => {
      const { filename, caption, lastEditedDate } = item;

      return {
        url: filename,
        description: caption,
        lastEditedDate
      };
    });

    let metaData;

    if (enableImageAnalytics) {
      metaData = {
        widgetId,
        widgetHeadline,
        adTag
      };
    }

    return [{
      headline: widgetHeadline,
      data: this._sliceItems(items).map(item => {
        return {
          bylines,
          ...item,
          ...metaData
        };
      })
    }];
  }

  _sliceItems(items) {
    const {
      startArticleIndex,
      numberOfItems
    } = this.props;

    return items.slice(startArticleIndex, numberOfItems <= 0 ? items.length : numberOfItems);
  }

  render() {
    const {
      FRN_rawResponses: [
        {
          data: {
            headline = '',
            features = [],
            widgets = []
          } = {}
        } = {}
      ] = [],
      title,
      titleColor,
      backgroundColor,
      ads,
      showAds,
      adPlacementPattern,
      selectedHighlightColor,
      maintainImageAspectRatio,
      imageAspectRatioBackgroundColor,
      showScrollBarOnGridview,
      showCaption,
      captionBackgroundColor,
      captionTextColor,
      showDrawer,
      showSettingsPill,
      settingsPillProperties,
      videoIconPlacement,
      showPagination,
      autoChangeInterval,
      autoPause,
      showTimestamp,
      showUpdatedDate,
      showBylines,
      timestampOptions,
      showDescription,
      showTitle,
      enableImageAnalytics,
      titleType,
      mode,
      enableAdRefresh
    } = this.props;

    const { items } = this.state;

    if (!items) {
      return null;
    }

    return (
      <div className="SlideshowWrapper" style={{ backgroundColor }}>
        {
          items.map((item, index) => {
            const finalTitle = mode === 'feed' ? item.headline : title;
            return (
              <div  className = "Slideshow" key={index}>
                {showTitle && finalTitle ? <ComponentTitle titleType={titleType} title={finalTitle} color={titleColor} /> : null}
                <Slideshow
                  FRN_page={this.props.FRN_page}
                  items={item.data}
                  backgroundColor={backgroundColor}
                  showCaption={showCaption}
                  captionBackgroundColor={captionBackgroundColor}
                  captionTextColor={captionTextColor}
                  showDrawer={showDrawer}
                  showSettingsPill={showSettingsPill}
                  settingsPillProperties={settingsPillProperties}
                  showPagination={showPagination}
                  maintainImageAspectRatio={maintainImageAspectRatio}
                  imageAspectRatioBackgroundColor={imageAspectRatioBackgroundColor}
                  showTimestamp={showTimestamp}
                  showUpdatedDate={showUpdatedDate}
                  showBylines={showBylines}
                  timestampOptions={timestampOptions}
                  showDescription={showDescription}
                  videoIconPlacement={videoIconPlacement}
                  ads={ads}
                  showAds={showAds}
                  autoChangeInterval={autoChangeInterval}
                  autoPause={autoPause}
                  showScrollBarOnGridview={showScrollBarOnGridview}
                  adPlacementPattern={adPlacementPattern}
                  selectedHighlightColor={selectedHighlightColor}
                  enableImageAnalytics={enableImageAnalytics}
                  enableAdRefresh={enableAdRefresh}
                />
              </div>
            );
          })
        }
      </div>
    );
  }
}

class Slideshow extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    ...SlideshowPropTypes
  }

  state = {
    index: 0,
    transitionName: '',
    isGridView: false,
    isFullScreen: false,
    activeAdIndex: 0,
    adStatusCounter: 0,
    showAd: false,
    paused: false
  }

  componentWillMount() {
    this._onBack = _.debounce(this._onBack, 500, { maxWait: 500, leading: true });
    this._onNext = _.debounce(this._onNext, 500, { maxWait: 500, leading: true });
  }

  componentDidMount() {
    const { items, enableImageAnalytics, autoChangeInterval } = this.props;

    if (enableImageAnalytics) {
      const firstItemMeta = {
        slideshowData: items[0],
        index: 1,
        numberOfItems: items.length
      };

      AnalyticsUtils.triggerSlideshowPageView(firstItemMeta);

      if (autoChangeInterval) {
        AnalyticsUtils.triggerSlideshowStart(firstItemMeta);
      }
    }

    this._startAutoChangeInterval();

    window.addEventListener('keydown', (event) => this._onEscapeKeyPress(event));
  }

  componentWillUnmount() {
    this._clearAutoChangeInterval();

    window.removeEventListener('keydown', (event) => this._onEscapeKeyPress(event));
  }

  _isAdInViewPort(adElement) {
    const id = '#' + adElement;
    const elementTop = $(id).offset().top;
    const elementBottom = elementTop + $(id).outerHeight();
    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  }

  _refreshAd() {
    const worldnow = window['Worldnow'];
    const existingAds = worldnow.AdMan.getAds();
    const prefix = worldnow.AdMan.DOM_ID_PREFIX;
    const adsInViewPort = existingAds.map(ad => {
      const adElement = prefix + ad.options.id;
      if (this._isAdInViewPort(adElement)) {
        return adElement;
      }
    });
    adsInViewPort.forEach(ad => {
      if (ad) {
        worldnow.AdMan.reloadAd(ad);
      }
    });
  }

  _onEscapeKeyPress(event) {
    const { keyCode } = event;

    if (keyCode === 27) {
      this.setState({ isFullScreen: false });
    }
  }

  _startAutoChangeInterval() {
    const { autoChangeInterval } = this.props;
    if (autoChangeInterval > 0 && !this.state.paused) {
      this.imageSlideshowInterval = setInterval(() => this._onNext(), autoChangeInterval * 1000);
    }
  }

  _clearAutoChangeInterval() {
    const { autoChangeInterval } = this.props;
    if (autoChangeInterval > 0) {
      clearInterval(this.imageSlideshowInterval);
    }
  }

  _onSwipe(e, x) {
    if (x > 0) {
      this._onNext(e);
    } else {
      this._onBack(e);
    }

  }

  _onNext(e) {
    if (this.props.enableAdRefresh) {
      this._refreshAd();
    }
    const {
      enableImageAnalytics,
      items
    } = this.props;

    let { index } = this.state;

    index = index === items.length - 1 ? 0 : index + 1;

    this._slide(index, TRANSITION_NEXT_CLASSNAME);

    if (enableImageAnalytics && e) {
      AnalyticsUtils.triggerSlideshowSlideNext({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
    }
  }

  _onBack(e) {
    if (this.props.enableAdRefresh) {
      this._refreshAd();
    }
    const {
      enableImageAnalytics,
      items
    } = this.props;

    let { index } = this.state;

    index = index === 0 ? items.length - 1 : index - 1;

    this._slide(index, TRANSITION_BACK_CLASSNAME);

    if (enableImageAnalytics && e) {
      AnalyticsUtils.triggerSlideshowSlideBack({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
    }
  }

  _onSelect(index) {
    if (this.props.enableAdRefresh && index !== this.state.index) {
      this._refreshAd();
    }
    const { index: currentIndex } = this.state;
    const transitionName = index > currentIndex ? TRANSITION_NEXT_CLASSNAME : TRANSITION_BACK_CLASSNAME;

    this._slide(index, transitionName);
  }

  _slide(index, transitionName) {
    const {
      enableImageAnalytics,
      items
    } = this.props;

    if (enableImageAnalytics) {
      AnalyticsUtils.triggerSlideshowPageView({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
    }

    this._clearAutoChangeInterval();

    const { adPlacementPattern, ads } = this.props;
    let { activeAdIndex, adStatusCounter, showAd } = this.state;

    if (adStatusCounter === adPlacementPattern) {
      adStatusCounter = 0;
      activeAdIndex = activeAdIndex === ads.length - 1 ? 0 : activeAdIndex + 1;
      showAd = true;
    } else {
      adStatusCounter++;
      showAd = false;
    }

    this.setState({
      index,
      activeAdIndex,
      adStatusCounter,
      showAd,
      transitionName
    });

    this._startAutoChangeInterval();
  }

  _onSelectInGridView(index) {
    this._onSelect(index);
    this._toggleGridView();
  }

  _onTouchTap() {
    return this.state.paused ? this._unpause() : this._pause();
  }

  _pause() {
    const {
      autoChangeInterval,
      autoPause,
      enableImageAnalytics,
      items
    } = this.props;

    const { index } = this.state;

    if (autoChangeInterval && autoPause){
      this._clearAutoChangeInterval();
      this.setState({ paused: true });

      if (enableImageAnalytics) {
        AnalyticsUtils.triggerSlideshowPause({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
      }
    }
  }

  _unpause() {
    const {
      autoChangeInterval,
      autoPause,
      enableImageAnalytics,
      items
    } = this.props;

    const { index } = this.state;

    if (autoChangeInterval && autoPause) {
      this.setState({ paused: false });
      setTimeout(() => !this.state.paused ? this._onNext() : null, 1500);

      if (enableImageAnalytics) {
        AnalyticsUtils.triggerSlideshowStart({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
      }
    }
  }

  _closeAd() {
    this.setState({
      showAd: false
    });
  }

  _toggleGridView() {
    let isGridView = !this.state.isGridView;

    if (isGridView) {
      this._clearAutoChangeInterval();
    }

    this.setState({
      isGridView
    });
  }

  _showFullScreen() {
    const { isFullScreen } = this.state;

    this.setState({
      isFullScreen: !isFullScreen
    });
  }

  render() {
    const {
      items,
      ads,
      showAds,
      backgroundColor,
      maintainImageAspectRatio,
      imageAspectRatioBackgroundColor,
      showScrollBarOnGridview,
      autoChangeInterval,
      showCaption,
      captionBackgroundColor,
      captionTextColor,
      showDrawer,
      showPagination,
      showSettingsPill,
      settingsPillProperties: {
        // TODO: Implement later
        // share = true,
        fullScreen = true,
        gridView = true,
        imageCounter = true
      },
      videoIconPlacement,
      showTimestamp,
      showUpdatedDate,
      showBylines,
      timestampOptions: {
        showElapsedTime,
        displayShortDateTime
      },
      showDescription,
      selectedHighlightColor,
      enableImageAnalytics
    } = this.props;

    const {
      isGridView,
      isFullScreen,
      transitionName,
      paused,
      index,
      activeAdIndex,
      showAd
    } = this.state;

    const {
      id,
      publishingDate,
      updatedDate,
      url: currentImageUrl,
      lastEditedDate = '',
      description: currentDescription = '',
      headline: currentHeadline = '',
      bylines,
      credits,
      link,
      type,
      slug
    } = items[index];

    const counterContent = (
      <span>{index + 1} / {items.length}</span>
    );

    const largeThumbnailStyles = {};

    largeThumbnailStyles['backgroundColor'] = imageAspectRatioBackgroundColor;

    if (maintainImageAspectRatio) {
      largeThumbnailStyles['backgroundSize'] = 'contain';
    } else {
      largeThumbnailStyles['backgroundSize'] = 'cover';
    }

    const largeThumbnailClassNames = classNames(
      'Slideshow-thumbnail',
      { [`VideoThumbnail VideoThumbnail-${videoIconPlacement}`]: type === CLIP }
    );

    const adContent = [];

    if (showAds) {
      ads.forEach((ad, i) => {
        adContent.push(
          <div key={i} className="Slideshow-ad" style={{display: !(showAd && activeAdIndex === i) ? 'none' : null, backgroundColor: imageAspectRatioBackgroundColor || backgroundColor }}>
            <div>
              <div className="Slideshow-ad--hide" onClick={() => this._closeAd()}><i className="fa fa-window-close"></i></div>
                <AdvertisementUnit {...ad} />
              </div>
          </div>
        );
      });
    }

    const imageSlideshowClassnames = classNames(
      'ImageSlideshow',
      { 'ImageSlideshow-fullscreen': isFullScreen }
    );

    const slideshowClassNames = classNames(
      'Slideshow',
      {'Slideshow--hidden': isGridView}
    );

    const gridViewContent = (showSettingsPill && gridView) ? <GridView
      items={items}
      index={index}
      showScrollBarOnGridview={showScrollBarOnGridview}
      selectedHighlightColor={selectedHighlightColor}
      isGridView={isGridView}
      isFullScreen={isFullScreen}
      select={(i) => this._onSelectInGridView(i)} /> : null;

    let timestamp;

    if (showTimestamp || showBylines) {
      const timestampDate = showUpdatedDate ? updatedDate : publishingDate;
      const authors = credits ? unescape(credits) : _.map(bylines, bylineToString);
      timestamp = <Timestamp publishDate={showTimestamp ? timestampDate : null} showElapsedTime={showElapsedTime} displayShortDateTime={displayShortDateTime} authors={showBylines ? authors : null} />;
    }

    const getLocation = () => typeof location !== 'undefined' ? location : this.props.FRN_page.uri;

    return (
      <div className={imageSlideshowClassnames}>
        {
          showScrollBarOnGridview ? <div className="GridView-wrapper">
            { gridViewContent }
          </div> : gridViewContent
        }
        <div className={slideshowClassNames} >
          <div className="Slideshow-main" onTouchTap={() => this._onTouchTap()} onMouseEnter={() => this._pause()} onMouseLeave={() => this._unpause()}>
            <ReactCSSTransitionGroup
              transitionName={transitionName}
              transitionEnterTimeout={750}
              transitionLeaveTimeout={750}
              className="Slideshow-container">
              <Swipeable key={index} className="Slideshow-swipe" onSwiped={(e, x) => this._onSwipe(e, x)}>
                <div className={largeThumbnailClassNames} style={largeThumbnailStyles}>
                  <Image height='580' src={`${decodeURIComponent(currentImageUrl)}`} alt={currentHeadline} lastEditedDate={lastEditedDate} />
                </div>
              </Swipeable>
            </ReactCSSTransitionGroup>
            {
              (showSettingsPill && (fullScreen || gridView || imageCounter)) && <div className="Slideshow-settings Slideshow-inactive">
                {/* TODO: Implement later
                  <div className="Slideshow-settings-icon Slideshow-settings--link"></div>
                */}
                { fullScreen && <div className="Slideshow-settings-icon Slideshow-settings--screen" onClick={() => this._showFullScreen()}></div> }
                { gridView && <div className="Slideshow-settings-icon Slideshow-settings--grid" onClick={() => this._toggleGridView()}></div> }
                { imageCounter && <div className="Slideshow-settings--counter frn-u-fontWeight-semibold">{counterContent}</div> }
              </div>
            }
            {
              showPagination && <div className="Slideshow-pagination Slideshow-pagination--left Slideshow-inactive" onClick={(e) => this._onBack(e)}>
                <SlideshowIcon direction="left"/>
              </div>
            }
            {
              showPagination && <div className="Slideshow-pagination Slideshow-pagination--right Slideshow-inactive" onClick={(e) => this._onNext(e)}>
                <SlideshowIcon direction="right"/>
              </div>
            }
            {autoChangeInterval > 0 && <div className="Slideshow-pause"><Pause paused={paused}/></div>}
            {
              showCaption && <a href={link ? getLocalLink(getLocation(), {id, type, slug, link}) : null}><div className="Slideshow-caption" style={{ backgroundColor: captionBackgroundColor, color: captionTextColor }}>
                <div className="Slideshow-headline frn-u-fontWeight-regular">
                  {unescape(currentHeadline)}
                </div>
                {
                  showDescription && <div className="Slideshow-description">
                    <p dangerouslySetInnerHTML={{__html: unescape(currentDescription) }} />
                  </div>
                }
                {timestamp}
              </div></a>
            }
            {adContent}
          </div>
          {
            showDrawer && <Drawer
            items={items}
            index={index}
            selectedHighlightColor={selectedHighlightColor}
            select={(i) => this._onSelect(i)}
            enableImageAnalytics={enableImageAnalytics}
            />
          }
        </div>
      </div>
    );
  }
}

class Drawer extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    index: PropTypes.number,
    selectedHighlightColor: PropTypes.string,
    select: PropTypes.func.isRequired,
    enableImageAnalytics: PropTypes.bool
  }

  state = {
    transform: 0,
    canNext: false,
    canBack: false,
    lastWidth: 0 // is used to checking if this is fullScreen
  }

  componentDidMount() {
    this._showNextArrow();
    this._setLastWidth();
  }

  componentWillReceiveProps(nextProps) {
    const { index: newIndex } = nextProps;
    const { index: currentIndex } = this.props;

    if (newIndex !== currentIndex) {
      this._transform(newIndex);
    }
  }

  componentDidUpdate() {
    const drawerWidth = this._getDrawerWidth();
    const { lastWidth } = this.state;

    if (lastWidth !== drawerWidth) {
      this._transform(this.props.index);
      this._setLastWidth();
    }
  }

  _setLastWidth() {
    this.setState({ lastWidth: this._getDrawerWidth() });
  }

  _onSwipe(e, x) {
    if (x > 0) {
      this._onNext();
    } else {
      this._onBack();
    }
  }

  _onNext() {
    const { items, index, enableImageAnalytics } = this.props;
    const { transform } = this.state;
    const drawerItemWidth = this._getDrawerItemWidth();
    const drawerWidth = this._getDrawerWidth();
    const numberOfThumbnailInView = this._getNumberOfThumbnailInView();
    const remainingWidth = items.length * drawerItemWidth - drawerWidth + transform;
    const offset = drawerItemWidth * numberOfThumbnailInView;

    let canNext = true;
    let newTransform = transform;

    if (remainingWidth < offset) {
      newTransform -= remainingWidth;
      canNext = false;
    } else {
      newTransform -= offset;

      if (offset === remainingWidth) {
        canNext = false;
      }
    }

    if (enableImageAnalytics) {
      AnalyticsUtils.triggerSlideshowDrawerNext({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
    }

    this.setState({
      transform: newTransform,
      canBack: true,
      canNext
    });
  }

  _onBack() {
    const { items, index, enableImageAnalytics } = this.props;
    let { transform } = this.state;
    const numberOfThumbnailInView = this._getNumberOfThumbnailInView();
    const drawerItemWidth = this._getDrawerItemWidth();
    const offset = drawerItemWidth * numberOfThumbnailInView;

    let canBack = true;
    let newTransform = transform;

    if (-transform < offset) {
      newTransform -= transform;
      canBack = false;
    } else {
      newTransform += offset;

      if (offset === -transform) {
        canBack = false;
      }
    }

    if (enableImageAnalytics) {
      AnalyticsUtils.triggerSlideshowDrawerBack({slideshowData: items[index], index: index + 1, numberOfItems: items.length });
    }

    this.setState({
      transform: newTransform,
      canBack,
      canNext: true
    });
  }

  _transform(index) {
    const { items } = this.props;
    const { transform } = this.state;
    const drawerItemWidth = this._getDrawerItemWidth();
    const drawerWidth = this._getDrawerWidth();
    const allThumbnailsWidth = items.length * drawerItemWidth;
    const exceededWidth = allThumbnailsWidth - drawerWidth;
    const remainingWidth = exceededWidth + transform;
    const currentPosition = (index) * drawerItemWidth + transform;
    const centerPosition = (drawerWidth - drawerItemWidth) / 2;

    let newTransform = transform;

    if (currentPosition > centerPosition) {
      if (remainingWidth > 0) {
        const offset = (currentPosition) - centerPosition;

        if (offset > remainingWidth) {
          newTransform -= remainingWidth;
        } else {
          newTransform -= offset;
        }
      } else {
        if (-transform + drawerWidth > allThumbnailsWidth) {
          newTransform = - exceededWidth;
        }
      }
    }

    if (currentPosition < centerPosition && transform < 0) {
      const offset = centerPosition - currentPosition;

      if (offset > (-transform)) {
        newTransform = 0;
      } else {
        newTransform += offset;
      }
    }

    if (allThumbnailsWidth <= drawerWidth) {
      newTransform = 0;
    }

    this.setState({
      transform: newTransform,
      canNext: -newTransform + drawerWidth < allThumbnailsWidth,
      canBack: newTransform < 0
    });
  }

  _showNextArrow() {
    if (this.props.items.length * this._getDrawerItemWidth() > this._getDrawerWidth()) {
      this.setState({ canNext: true });
    }
  }

  _getNumberOfThumbnailInView() {
    return Math.floor(this._getDrawerWidth() / this._getDrawerItemWidth());
  }

  _getDrawerItemWidth() {
    return this.drawerItem && this.drawerItem.offsetWidth;
  }

  _getDrawerWidth() {
    return this.drawer && this.drawer.offsetWidth;
  }

  render() {
    const {
      items,
      index,
      selectedHighlightColor,
      select
    } = this.props;

    const {
      transform,
      canNext,
      canBack
    } = this.state;

    const drawerContent = items.map((item, i) => {
      const {
        url: imageUrl,
        lastEditedDate = '',
        headline
      } = item;

      const itemClassnames = classNames(
        'Drawer-itemContent',
        'GridItem-itemContent',
        { 'GridItem-active': i === index }
      );

      const thumbnailStyles = {};

      thumbnailStyles['backgroundSize'] = 'cover';

      return (
        <div className="Drawer-itemWrapper frn-u-padding-xs" key={i} ref={(div) => this.drawerItem = div} onClick={() => select(i)}>
          <div className={itemClassnames} style={{ outlineColor: i === index ? selectedHighlightColor : null }}>
            <div className="Drawer-item GridItem-item" style={thumbnailStyles}>
              <Image width='240' src={`${decodeURIComponent(imageUrl)}`} alt={headline} lastEditedDate={lastEditedDate}/>
            </div>
          </div>
        </div>
      );
    });

    return (
      <div className="Drawer" ref={(div) => this.drawer = div}>
        {canBack ? <div className="Drawer-backBtn" onClick={() => this._onBack()}><SlideshowIcon direction="left" /></div> : null}
        <Swipeable onSwiped={(e, x) => this._onSwipe(e, x)}>
          <div className="Drawer-items" style={{transform: `translate(${transform}px, 0)`, transition: `all 0.25s linear`}}>
            {drawerContent}
          </div>
        </Swipeable>
        {canNext ? <div className="Drawer-nextBtn" onClick={() => this._onNext()}><SlideshowIcon direction="right" /></div> : null}
      </div>
    );
  }
}

class GridView extends Component {
  static propTypes = {
    items: PropTypes.array.isRequired,
    index: PropTypes.number,
    showScrollBarOnGridview: PropTypes.bool,
    selectedHighlightColor: PropTypes.string,
    isGridView: PropTypes.bool,
    isFullScreen: PropTypes.bool,
    select: PropTypes.func.isRequired
  }

  state = {
    startIndex: 0,
    numberOfGridColumn: null,
    numberOfGridItems: null
  }

  componentDidMount() {
    this._updateDimensions();
    window.addEventListener('resize', () => this._updateDimensions());
  }

  componentWillReceiveProps(nextProps) {
    const { isGridView } = nextProps;

    if (isGridView) {
      const { showScrollBarOnGridview } = this.props;

      if (!showScrollBarOnGridview) {
        this._showSelectedThumbnailPage();
      } else {
        this._scrollToSelectedThumbnail();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', () => this._updateDimensions());
  }

  _updateDimensions() {
    const windowWidth = window && window.screen.width;

    let numberOfGridColumn;
    let numberOfGridItems;

    for (let i = 0; i < BREAKPOINTS.length; i++){
      if (BREAKPOINTS[i].minWidth <= windowWidth) {
        if (i + 1 === BREAKPOINTS.length || BREAKPOINTS[i + 1].minWidth > windowWidth) {
          numberOfGridColumn = BREAKPOINTS[i].numberOfGridColumn;
          numberOfGridItems = BREAKPOINTS[i].numberOfGridItems;

          break;
        }
      }
    }

    this.setState({
      numberOfGridColumn,
      numberOfGridItems
    });
  }

  _onSwipe(e, x) {
    if (x > 0) {
      this._onNext();
    } else {
      this._onBack();
    }
  }

  _onNext() {
    const { items } = this.props;
    const { startIndex, numberOfGridItems } = this.state;

    const nextIndex = startIndex + numberOfGridItems;

    if (items.length > nextIndex) {
      this.setState({
        startIndex: nextIndex
      });
    }
  }

  _onBack() {
    const { startIndex, numberOfGridItems } = this.state;

    if (startIndex > 0) {
      this.setState({
        startIndex: startIndex - numberOfGridItems
      });
    }
  }

  _scrollToSelectedThumbnail() {
    const { index } = this.props;
    const { numberOfGridColumn, numberOfGridItems } = this.state;

    const newStartIndex = Math.floor(index / numberOfGridItems) * numberOfGridItems;

    const posTop = (newStartIndex / numberOfGridColumn) * this._getGridViewItemHeight();

    this.gridViewContainer.scrollTop = posTop;
  }

  _showSelectedThumbnailPage() {
    const { index } = this.props;
    const { numberOfGridItems } = this.state;

    this.setState({
      startIndex: Math.floor(index / numberOfGridItems) * numberOfGridItems
    });
  }

  _getGridViewItemHeight() {
    return this.gridViewItem.offsetHeight;
  }

  render() {
    const {
      items,
      index,
      selectedHighlightColor,
      showScrollBarOnGridview,
      isFullScreen,
      isGridView,
      select
    } = this.props;

    const {
      startIndex,
      numberOfGridColumn,
      numberOfGridItems
    } = this.state;

    const gridViewContent = (!showScrollBarOnGridview ? items.slice(startIndex, startIndex + numberOfGridItems) : items).map((item, i) => {
      const {
        url: imageUrl,
        lastEditedDate = '',
        headline
      } = item;

      const itemClassnames = classNames(
        'GridItem-itemContent',
        'GridItem-itemContent',
        { 'GridItem-active': startIndex + i === index }
      );

      const gridViewContentStyles = {};

      if (isFullScreen && !showScrollBarOnGridview) {
        gridViewContentStyles['height'] = 100 / (numberOfGridItems / numberOfGridColumn) + '%';
      }

      const gridViewStyles = {};

      gridViewStyles['backgroundSize'] = 'cover';

      return (
        <div className="GridView-content frn-u-padding-xxs" key={i} ref={i === 0 ? (div) => this.gridViewItem = div : null} onClick={() => select(startIndex + i)} style={gridViewContentStyles}>
          <div className="GridView-itemWrapper">
            <div className={itemClassnames} style={{ outlineColor: startIndex + i === index ? selectedHighlightColor : null }}>
              <div className="GridView-item GridItem-item" style={gridViewStyles}>
                <Image width='348' height='196' src={`${decodeURIComponent(imageUrl)}`} alt={headline} lastEditedDate={lastEditedDate}/>
              </div>
            </div>
          </div>
        </div>
      );
    });

    const gridViewClassNames = classNames(
      'GridView',
      {'GridView--hidden': !isGridView},
      {'GridView--pageable': !showScrollBarOnGridview}
    );

    const gridViewContentClassnames = classNames(
      'GridView-main',
      {'GridView-main--scrollable': showScrollBarOnGridview},
      {'GridView-main--pageable': !showScrollBarOnGridview},
    );

    return (
      <div className={gridViewClassNames}>
        {
          !showScrollBarOnGridview && <div className="GridView-pagination">
            <button onClick={() => this._onBack()}>
              <Pagination direction="left"/>
            </button>
            <button onClick={() => this._onNext()}>
              <Pagination direction="right"/>
            </button>
          </div>
        }
        <div className={gridViewContentClassnames} ref={(div) => this.gridViewContainer = div}>
          {
            !showScrollBarOnGridview ? <Swipeable className="GridView-swipe" onSwiped={(e, x) => this._onSwipe(e, x)}>
              {gridViewContent}
            </Swipeable> : gridViewContent
          }
        </div>
      </div>
    );
  }
}

export default SlideshowWrapper;



// WEBPACK FOOTER //
// ./app/components/news/Slideshow.js